<template>
  <div class="container content">
    <h1 class="breadcrumb">
      {{ $t('Dashboard') }}
    </h1>
    <h2 class="teacherHeading">
      {{ $t('Erstellte Lernpfade') }}
    </h2>
    <ul
      v-if="teacherPaths && teacherPaths.length > 0"
      class="learnPaths mt-4"
    >
      <b-row>
        <b-col
          cols="12"
          sm="6"
          lg="3"
          class="dashboardItems p-3"
        >
          <div class="coverAndCard card">
            <div class="coverImage addNewPathCard_parent">
              <div class="addNewPathCard">
                <div class="addNewPathText">
                  <a @click="newLearnPath">
                    <p class="plus">+</p>
                    <h3 class="addNewPathTitle">
                      {{ $t('Neuen Lernpfad erstellen') }}!
                    </h3>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </b-col>

        <!-- Learning paths -->
        <b-col
          v-for="(item, index) in teacherPaths"
          :key="index"
          cols="12"
          sm="6"
          lg="3"
          class="dashboardItems p-3"
        >
          <div class="coverAndCard">
            <nuxt-link
              :to="localePath(`/pfad/${item.node.ref}/admin`)"
              class=""
            >
              <CoverImage
                :coverimg="item.node.coverImage"
                :editable="false"
                :lpref="item.node.ref"
                class="coverImage"
                :in-l-p="false"
              />
            </nuxt-link>
            <Card
              class="card"
              :to="localePath(`/pfad/${item.node.ref}/admin`)"
              :title="
                item.node.title !== '' ? item.node.title : $t('Ohne Titel')
              "
              :text="item.node.text"
              :lpref="item.node.ref"
              :student-count="item.node.studentCount"
              :created="item.node.created"
              :published-lib="item.node.public"
              :published-pro="item.node.onTeachersProfile"
              :publication="true"
            />
          </div>
        </b-col>
      </b-row>
    </ul>
    <div v-else>{{ $t('Du hast noch keinen Lernpfad erstellt') }}.</div>
    <div class="newButton">
      <a
        class="btnLink"
        @click="newLearnPath"
      >
        <plusSvg />
        {{ $t('Neuen Lernpfad erstellen') }}
      </a>
    </div>
    <h2 class="studentHeading">{{ $t('Zu bearbeitende Lernpfade') }}</h2>
    <ul
      v-if="teacherPaths && studentPaths.length > 0"
      class="learnPaths mt-4"
    >
      <b-row>
        <b-col
          v-for="(item, index) in studentPaths"
          :key="index"
          cols="12"
          sm="6"
          lg="3"
          class="dashboardItems receivedPaths p-3"
        >
          <div class="coverAndCard">
            <nuxt-link
              :to="localePath(`/pfad/${item.node.ref}`)"
              class=""
            >
              <CoverImage
                :coverimg="item.node.coverImage"
                :editable="false"
                :lpref="item.node.ref"
                class="coverImage"
                :in-l-p="false"
              />
            </nuxt-link>
            <Card
              class="card"
              :to="localePath(`/pfad/${item.node.ref}`)"
              :title="item.node.title !== '' ? item.node.title : 'Ohne Titel'"
              :text="item.node.text"
              :lpref="item.node.ref"
              :created="item.node.created"
              :coverimg="item.node.coverImage"
            />
          </div>
        </b-col>
      </b-row>
    </ul>
    <div v-else>{{ $t('Du hast noch keinen Lernpfad geteilt erhalten') }}.</div>
  </div>
</template>

<script>
import LearnPathUtils, { getEmptyStep } from '../mixins/LearnPathUtils'
import { ampli } from '../mixins/Amplitude/index.js'
import plusSvg from '../assets/images/plus.svg'
import Card from './ui/Card'
import CoverImage from './ui/CoverImage'

export default {
  components: {
    Card,
    CoverImage,
    plusSvg,
  },

  mixins: [LearnPathUtils, ampli],

  props: {
    learnPaths: {
      type: Array,
      required: true,
    },
  },

  computed: {
    teacherPaths() {
      return this.learnPaths.filter((l) => l.node.role === 'teacher')
    },
    studentPaths() {
      return this.learnPaths.filter((l) => l.node.role !== 'teacher')
    },
  },
  created() {
    ampli.dashboardPageViewed()
  },
  methods: {
    async newLearnPath() {
      const learnPath = {
        title: '',
        text: '',
        steps: [getEmptyStep(), getEmptyStep(), getEmptyStep()],
      }

      const pathRef = await this.saveLearnPath(learnPath)
      this.$router.push(this.localePath({ path: `/pfad/${pathRef}/admin/` }))
    },
  },
}
</script>

<style
  lang="scss"
  scoped
>
@import '../assets/style/vars';
@import '../assets/style/utils';

.coverImage {
  flex-grow: 1;
  width: 100%;
}

.newButton {
  margin: calculateRem(60px) 0 calculateRem(40px) 0;
  cursor: pointer;
}

.learnPaths {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.coverAndCard {
  box-shadow: 0 4px 12px 0 #e5e5e5;
  height: 100%;

  &:hover {
    transform: scale(1.01);
  }
}

.teacherHeading {
  margin-top: calculateRem(40px);
}

.studentHeading {
  margin-top: calculateRem(120px);
}

.addNewPathCard_parent {
  height: 100%;
}

.addNewPathCard {
  margin-bottom: calculateRem(20px);
  height: 100%;
  display: flex;
  width: 100%;
  flex-direction: column;
  border: 3px dashed #74bef7;
  padding: 10px;
  cursor: pointer;
}

.addNewPathText {
  text-align: center;
  margin-top: 15%;
  padding: 10px;
}

.addNewPathTitle {
  font-size: 20px;
  color: #0f0a3b;
  font-weight: 700;
}

.plus {
  font-size: 72px;
  color: #0f0a3b;
  line-height: 90px;
}
</style>
